<template>
  <div>
    <agile-table
      :data-type="'workOrdersPerProject'"
      :data="workOrders"
      :filter-meta="filterMeta"
      :table-meta="tableMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      :showContextMenu="true"
      @tableControlAction="tableControlAction"
      @rowAction="rowAction"
      @tableAction="tableAction"
      @fieldAction="fieldAction" />
    <new-button v-if="displayCreateButton" @clicked="openWorkOrderModal(0)" />
    <slideout-panel />
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import WorkOrderModal from '@/components/modals/WorkOrderModal'
import AgileTable from '@/components/table/AgileTable'
import ProjectModal from '@/components/modals/ProjectModal'
import CustomerModal from '@/components/modals/CustomerModal'
import UserModal from '@/components/modals/UserModal'

export default {
  components: {
    NewButton,
    WorkOrderModal,
    AgileTable
  },

  props: {
    displayCreateButton: {
      type: Boolean,
      default: true
    },

    projectCode: {
      type: String
    },

    workOrderOwnerUserId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      project: null,

      tableMeta: {
        headingIcon: 'fa-boxes',
        controls: [
        // {
        //   label: 'Status',
        //   placeholder: 'Alla',
        //   action: 'filterByStatus',
        //   controlType: 'select',
        //   options: [{
        //     key: 'quoted',
        //     value: 'Offererad'
        //   }, {
        //     key: 'planned',
        //     value: 'Planerad'
        //   }, {
        //     key: 'started',
        //     value: 'Pågående'
        //   }, {
        //     key: 'registered',
        //     value: 'Registrerad'
        //   }, {
        //     key: 'invoiced',
        //     value: 'Fakturerad'
        //   }, {
        //     key: 'cancelled',
        //     value: 'Makulerad'
        //   }],
        //   value: null
        // },
          {
            fieldId: 'statuses',
            label: 'Status',
            placeholder: 'Alla',
            action: 'filterByStatuses',
            controlType: 'multi-select',
            options: [],
            value: null
          }
        ],

        actions: [{
          label: 'Ändra status',
          action: 'setStatusAll',
          iconClass: 'fal fa-stream'
        },
        /* {
          label: 'Fakturera',
          action: 'pushToInvoice',
          iconClass: 'fal fa-file-invoice-dollar'
        }, */
        {
          label: 'Leverans',
          action: 'openDeliveryTemplatePopup',
          iconClass: 'fal fa-truck'
        },
        {
          label: 'Eportera',
          action: 'exportToExcel',
          iconClass: 'fal fa-file-excel'
        }]
      },

      filterMeta: [{
        fieldId: 'startDate',
        type: 'date',
        label: 'Startdatum'
      },
      {
        fieldId: 'endDate',
        type: 'date',
        label: 'Slutdatum'
      },
      {
        fieldId: 'statuses',
        type: 'multi-select',
        placeholder: 'Välj status',
        options: [],
        label: 'Status'
      },
      // {
      //   fieldId: 'status',
      //   type: 'select',
      //   label: 'Status',
      //   options: [{
      //     key: 'planned',
      //     value: 'Planerad'
      //   }, {
      //     key: 'started',
      //     value: 'Pågående'
      //   }, {
      //     key: 'registered',
      //     value: 'Registrerad'
      //   }, {
      //     key: 'invoiced',
      //     value: 'Fakturerad'
      //   }, {
      //     key: 'cancelled',
      //     value: 'Makulerad'
      //   }]
      // },
      {
        fieldId: 'ownerOrHelperInitials',
        type: 'string',
        label: 'Insatser tillhörande'
      },
      {
        fieldId: 'projectCode',
        type: 'string',
        label: 'Projektnummer'
      },
      {
        fieldId: 'objectName',
        type: 'string',
        label: 'Objekt'
      },
      {
        fieldId: 'customerName',
        type: 'string',
        label: 'Kund'
      },
      {
        fieldId: null
      },
      {
        fieldId: 'workOrderOwnerInitials',
        type: 'string',
        label: 'Ägare (Initialer)'
      },
      {
        fieldId: 'workOrderHelperInitials',
        type: 'string',
        label: 'Stöd (Initialer)'
      },
      {
        fieldId: 'invoiceNote',
        type: 'string',
        label: 'Extern not'
      },
      {
        fieldId: 'internalNote',
        type: 'string',
        label: 'Intern not'
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'verificationDate',
          label: 'Datum',
          dataType: 'date'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'objectName',
          label: 'Objekt'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'invoiceNote',
          label: 'Extern not'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'customerName',
          label: 'Kund'
          // actionType: 'fieldAction',
          // action: 'displayCustomer'
        },
        {
          fieldId: 'projectCode',
          label: 'Projektnummer',
          actionType: 'fieldAction',
          action: 'displayProject'
        },
        {
          fieldId: 'status',
          label: 'Status',
          dataType: 'translate',
          translations: [{
            key: 'Quoted',
            value: 'Offererad'
          }, {
            key: 'Planned',
            value: 'Planerad'
          }, {
            key: 'Started',
            value: 'Pågående'
          }, {
            key: 'Registered',
            value: 'Registrerad'
          }, {
            key: 'Invoiced',
            value: 'Fakturerad'
          }, {
            key: 'Cancelled',
            value: 'Makulerad'
          }]
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        /*
        {
          fieldId: 'createdByUserInitials',
          label: 'Skapad av'
          // actionType: 'fieldAction',
          // action: 'displayCreatorUser'
        },
        */
        {
          fieldId: 'workOrderOwnerDisplayText',
          label: 'Ägare'
          // actionType: 'fieldAction',
          // action: 'displayOwnerUser'
        },
        {
          fieldId: 'workOrderHelperDisplayText',
          label: 'Stöd'
          // actionType: 'fieldAction',
          // action: 'displayHelperUser'
        },
        {
          fieldId: 'internalNote',
          label: 'Intern not'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'hoursEstimated',
          label: 'Est. tid',
          dataType: 'number',
          disableOrdering: true,
          suffix: 'h'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'hoursWorked',
          label: 'Arb. tid',
          dataType: 'number',
          disableOrdering: true,
          suffix: 'h'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'invoiceableHours',
          label: 'Deb. tid',
          dataType: 'number',
          disableOrdering: true,
          suffix: 'h'
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        },
        {
          fieldId: 'value',
          label: 'Värde',
          dataType: 'currency',
          disableOrdering: true
          // actionType: 'fieldAction',
          // action: 'displayWorkOrder'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          action: 'updateWorkOrder',
          iconClass: 'fal fa-pen'
        }]
      },

      deliveryTemplates: []
    }
  },

  watch: {
    'workOrders.filter': {
      handler () {
        this.tableMeta.controls.find(x => x.action === 'filterByStatuses').value = this.workOrders.filter.statuses
        this.getListData()
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      workOrders: state => state.workOrdersPerProject.all
    })
  },

  methods: {
    ...mapActions('workOrdersPerProject', ['initialize', 'getListData', 'delete', 'createWorkOrdersFromDeliveryTemplate', 'setWorkOrderStatusForList', 'exportToExcel']),
    ...mapActions('deliveryTemplates', ['getAll']),
    ...mapActions('projects', ['getByProjectCode']),
    ...mapGetters('workOrdersPerProject', ['getStatusOptions']),

    tableControlAction (control) {
      switch (control.action) {
        case 'createWorkOrdersFromDeliveryTemplate':
          const deliveryTemplate = this.deliveryTemplates.find(x => x.deliveryTemplateId === control.value)
          this.$confirm('Skapa insatser från ' + deliveryTemplate.name + '?', 'Detta kommer att skapa upp ' + deliveryTemplate.numberOfItems + ' insatser').then(result => {
            if (result.value) {
              this.createWorkOrdersFromDeliveryTemplate({ projectCode: this.projectCode, deliveryTemplateId: control.value })
            }
          })
          break
        case 'filterByStatus':
          this.workOrders.filter.status = control.value
          break
        case 'filterByStatuses':
          this.workOrders.filter.statuses = control.value
          break
      }
    },

    tableAction (action) {
      switch (action) {
        case 'exportToExcel':
          let exportHtml = '<p>Exportera urval til Excelfil</p>'
          exportHtml += '<div style="text-align: left">'
          exportHtml += '<label class="label">Mall</label>'
          exportHtml += '<div class="select"><select id="template">'
          exportHtml += '<option value="quotation">Offert</option>'
          exportHtml += '<option value="detailed">Detaljerad</option>'
          exportHtml += '</select></div>'
          exportHtml += '</div>'

          this.$alert({
            title: 'Exportera till Excel',
            html: exportHtml,
            showCancelButton: true,
            confirmButtonText: 'Exportera',
            cancelButtonText: 'Avbryt',
            preConfirm: () => {
              return [
                document.getElementById('template').value
              ]
            }
          }).then(result => {
            if (result.value) {
              const template = result.value[0]
              this.exportToExcel({ projectCode: this.project.projectCode, filter: this.workOrders.filter, template })
            }
          })
          break
        case 'setStatusAll':
          let setStatusHtml = '<p>Detta kommer ändra status på följande insatser</p>'

          setStatusHtml += '<ul style="text-align:left; font-size: 0.8rem; margin-left: 9rem; margin-top: 1rem;">'
          // console.log(this.workOrders.items.map(x => `<li>${x.invoiceNote}</li>`))

          setStatusHtml += this.workOrders.items.map(x => `<li>${x.invoiceNote}</li>`).join('')
          setStatusHtml += '</ul>'

          setStatusHtml += '<div style="text-align: left">'
          setStatusHtml += '<label class="label">Ny status</label>'
          setStatusHtml += '<div class="select"><select id="new-status">'
          setStatusHtml += '<option value="Quoted">Offererad</option>'
          setStatusHtml += '<option value="Planned">Planerad</option>'
          setStatusHtml += '<option value="Registered">Registrerad</option>'
          setStatusHtml += '</select></div>'
          setStatusHtml += '</div>'

          this.$alert({
            title: 'Ändra status',
            html: setStatusHtml,
            showCancelButton: true,
            confirmButtonText: 'Ändra status',
            cancelButtonText: 'Avbryt',
            preConfirm: () => {
              return [
                document.getElementById('new-status').value
              ]
            }
          }).then(result => {
            if (result.value) {
              const newStatus = result.value[0]
              this.setWorkOrderStatusForList({ workOrderIds: this.workOrders.items.map(x => x.workOrderId), newStatus })
            }
          })
          break
        case 'pushToInvoice':
          this.$router.push({ name: 'Invoices_Project', params: { projectCode: this.projectCode } })
          break
          /* case 'openProjectModal':
          this.$panel(ProjectModal, { id: this.project.projectId })
          break */

        case 'openDeliveryTemplatePopup':
          let options = {}

          let html = '<div style="text-align: left">'
          html += '<label class="label">Leveransmall</label>'
          html += '<div class="select"><select id="delivery-template-id">'

          for (let deliveryTemplate of this.deliveryTemplates) {
            options[deliveryTemplate.deliveryTemplateId] = deliveryTemplate.name
            html += '<option value="' + deliveryTemplate.deliveryTemplateId + '">' + deliveryTemplate.name + '</option>'
          }

          html += '</select></div>'

          html += '<label class="label" style="margin-top: 2rem;">Status</label>'
          html += '<div class="select"><select id="delivery-template-status">'
          html += '<option value="Quoted">Offererad</option>'
          html += '<option value="Planned">Planerad</option>'
          html += '<option value="Registered">Registrerad</option>'
          html += '</select></div>'
          html += '</div>'

          this.$alert({
            title: 'Skapa leverans',
            text: 'Detta kommer skapa insatser från leveransmall',
            html: html,
            // input: 'select',
            // inputOptions: options,
            // inputPlaceholder: 'Välj leveransmall',
            showCancelButton: true,
            confirmButtonText: 'Skapa',
            cancelButtonText: 'Avbryt',
            preConfirm: () => {
              return [
                document.getElementById('delivery-template-id').value,
                document.getElementById('delivery-template-status').value
              ]
            }
          }).then(result => {
            if (result.value) {
              const deliveryTemplateId = parseInt(result.value[0])
              const deliveryStatus = result.value[1]
              const deliveryTemplate = this.deliveryTemplates.find(x => x.deliveryTemplateId === deliveryTemplateId)
              this.$confirm('Skapa insatser från ' + deliveryTemplate.name + '?', 'Detta kommer att skapa upp ' + deliveryTemplate.numberOfItems + ' insatser').then(result => {
                if (result.value) {
                  this.createWorkOrdersFromDeliveryTemplate({ projectCode: this.projectCode, deliveryTemplateId: deliveryTemplateId, status: deliveryStatus })
                }
              })
            }
          })
          break
      }
    },

    rowAction (action, workOrder) {
      switch (action) {
        case 'updateWorkOrder':
          this.openWorkOrderModal(workOrder.workOrderId)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, workOrder) {
      switch (action) {
        case 'displayCustomer':
          this.$panel(CustomerModal, { id: workOrder.customerId }).then(() => {
            // this.getProjectsList() // Why?
          })
          break
        case 'displayProject':
          this.$panel(ProjectModal, { id: workOrder.projectId })
          break
        case 'displayOwnerUser':
          if (!workOrder.workOrderOwnerUserId) {
            return
          }
          this.$panel(UserModal, { id: workOrder.workOrderOwnerUserId }).then(() => {
            // this.getProjectsList() // Why?
          })
          break
        case 'displayHelperUser':
          if (!workOrder.workOrderHelperUserId) {
            return
          }
          this.$panel(UserModal, { id: workOrder.workOrderHelperUserId }).then(() => {
            // this.getProjectsList() // Why?
          })
          break
        case 'displayWorkOrder':
          this.$panel(WorkOrderModal, { projectCode: workOrder.projectCode, workOrderId: workOrder.workOrderId }, 1000)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openWorkOrderModal (workOrderId) {
      this.$panel(WorkOrderModal, { projectCode: this.projectCode, workOrderId }, 1000).then(() => {
        this.getListData()
      })
    }
  },

  created () {
    // TODO: Denna måste ligga i nån form av route change
    this.workOrders.defaultFilter.projectCode = this.projectCode

    this.initialize()

    this.getAll().then(x => {
      this.deliveryTemplates = x
    })

    this.getByProjectCode(this.projectCode).then(project => {
      this.project = project
    })

    this.filterMeta.find(x => x.fieldId === 'statuses').options = this.getStatusOptions()
    this.tableMeta.controls.find(x => x.fieldId === 'statuses').options = this.getStatusOptions()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/WorkOrders/WorkOrderList.vue